import React, { Component } from 'react';
import { currentUser } from '../../services/CurrentUser'
import Routing from '../../utils/Routing'
import EirCard from '../eircard/EirCard';
import OfferModal from '../offer-modal/offerModal';
import PubSub from 'pubsub-js';
import Constants from '../../Constants';
import ResponsiveEirCardContainer from '../ResponsiveEirCardConatiner/ResponsiveEirCardContainer';
import Loading from '../shared/Loading';
import { Dd } from 'glamorous';
import { isNull } from 'util';
// import EirCardPrequal from '../eircard/EirCardPrequal'
class EirCardContainer extends Component {
  constructor(props) {
    super(props);

    this.priceIndex = 0;
    this.modalChangedToken = null;
    this.state = {
      isLoading: false,
      userInputRequired: false,
      selectedToggleAttribute: null,
      toggleAttributes: this.getAllToggleAttributes(),
      maxDropDownLines: 0,
      useChat:null,
      priceArray:null,
      subtitleFake:null,
    };
  }

  componentWillUnmount() {
    if (this.modalChangedToken) {
      PubSub.unsubscribe(this.modalChangedToken);
    }

    if (this.cartContentChangedTokenn) {
      PubSub.unsubscribe(this.cartContentChangedToken);
    }
  }

  async componentDidMount() {
    this.cartContentChangedToken = PubSub.subscribe(Constants.eventKeys.cartContentChanged, this.cartContentChanged);
    this.modalChangedToken = PubSub.subscribe(Constants.eventKeys.modalContentSelected, this.modalValueSelected);
    let selectedToggleAttribute = null;

    if (this.props.toggleAttributeName) {
      // first check the query string for a value
      let selectedToggleValue = Routing.getQueryParameter(this.props.toggleAttributeName);

      // if the query string came up with nothing, check if the user has it set
      if (selectedToggleValue == null) {
        selectedToggleValue = currentUser.getAttribute(this.props.toggleAttributeName);
      }

      this.props.bundleOfferLists.forEach(bundleOfferList => {
        bundleOfferList.attributes.forEach(attribute => {
          if (attribute.name === this.props.toggleAttributeName && attribute.value && attribute.value === selectedToggleValue) {
            selectedToggleAttribute = attribute;
          }
        });
      });
    }

    this.handleToggleValueSelected(selectedToggleAttribute);
    // set LS for accesing the offers in customise page - 
    localStorage.setItem("bundleDetails", JSON.stringify(this.props.bundleOfferLists[0].bundleOffers));

    if((this.props.bundleOfferLists[0].bundleOffers.filter( ({ id }) => id === '2V_CHAT' )).length>0){
      this.setState({useChat: '2V_CHAT',});
      this.setState({priceArray: [{priceFormatted: "39.99"},],});
      this.setState({subtitleFake: ['A MONTH FOR 24 MONTHS'],});
    }
    if((this.props.bundleOfferLists[0].bundleOffers.filter( ({ id }) => id === '3PTV_CHAT' )).length>0){
      this.setState({useChat: '3PTV_CHAT',});
      this.setState({priceArray: [{priceFormatted: "49.98"},],});
      this.setState({subtitleFake: ['A MONTH FOR 24 MONTHS'],});
    }
    
  }

  getSubtitles = (bundleOffer) => {

    // Generating subtitles for bundles cards
    var priceBreakdown = bundleOffer.priceBreakdown;
    // Fetch static subtitles from backend
    var subtitles = bundleOffer.attributes.filter(attribute => attribute.name === 'strapline').map(attribute => attribute.value);
    // Construct dymanic subtitles if required
    if (priceBreakdown.length > 1 || subtitles.length == 0) {
      subtitles = [];
      // Flag to indicate presence of once-off costs like activation fee, installation fee, etc
      var onceOffFees = false;
      // Flag to indicate an additional promo on top of the for life offer
      var forLifePromo = false;
      for (var i = 0; i < priceBreakdown.length; i++) {
        var price = priceBreakdown[i];
        // Generating subtitles for bundles with broadband
        if (this.props.prequalOnly) {
          // Generating subtitles for FOR LIFE bundles
          if (bundleOffer.id.endsWith("_FL")) {
            // if there is any promotions
            if (price.activePromos != null && price.activePromos.length != 0 && !forLifePromo) {
              subtitles.push('A MONTH FOR ' + price.months + ' MONTHS');
              forLifePromo = true;
            } else if (forLifePromo) {
              subtitles.push('€' + price.priceFormatted + ' A MONTH FOR LIFE');
              break;
            } else {
              // If no promotions
              subtitles.push('FOR LIFE');
              subtitles.push('');
            }
          } else {
            // Generating subtitles for FOR broadband and TV bundles page
            if (price.months === 1) {
              // Continue the loop and come back with next iteration becasue we don't want to display 1st month additional costs
              onceOffFees = true;
              continue;
            } else {
              if (i === 0 || onceOffFees) {
                subtitles.push('A MONTH FOR ' + (price.months + price.startMonth) + ' MONTHS');
                onceOffFees = false;
              }/*EIR-1835
              else if (i === priceBreakdown.length - 1) {
                subtitles.push('€' + price.priceFormatted + ' A MONTH THEREAFTER')
              }
               else {
                subtitles.push('€' + price.priceFormatted + ' A MONTH FOR NEXT ' + price.months + ' MONTHS')
              }*/
            }
          }
        }
        // Generating subtitles for Standalone Mobile bundles
        else {
          if (i === 0) {
            subtitles.push('A MONTH FOR ' + price.months + ' MONTHS');
          }
          else if (i === priceBreakdown.length - 1) {
            subtitles.push('€' + price.priceFormatted + ' A MONTH THEREAFTER');
          }
          else {
            subtitles.push('€' + price.priceFormatted + ' A MONTH FOR ' + price.months + ' MONTHS');
          }
        }
      }
    }
    return subtitles
  };

  //added as a part of React Card module - to get the subtitles for the cards
  getPriceBreakDown = (bundleOffer) => {

    var priceBreakdown = bundleOffer.priceBreakdown;
    var subtitles = bundleOffer.attributes.filter(attribute => attribute.name === 'strapline').map(attribute => attribute.value);
    if (priceBreakdown.length > 1) {
      subtitles = [];
      for (var i = 0; i < priceBreakdown.length; i++) {
        var price = priceBreakdown[i];
        if (i === 0) {
          subtitles.push('A MONTH FOR ' + price.months + ' MONTHS')
        }/*EIR-1835
        else if (i === priceBreakdown.length - 1) {
          subtitles.push('€' + price.priceFormatted + ' A MONTH THEREAFTER')
        }
         else {
          subtitles.push('€' + price.priceFormatted + ' A MONTH FOR ' + price.months + ' MONTHS')
        }*/
      }
    }
    return subtitles
  };

  getActivationFee = (standardFees) => {
    if (standardFees.length > 1) {
      for (var i = 0; i < standardFees.length; i++) {
        var fee = standardFees[i];
        var feePrice = fee.feeAmount;
        var feeType = fee.feeType;
        if (feeType === "ACTIVATION") {
          if (parseFloat(feePrice) > 0.0) {
            return (feePrice)
          }
        }
      }
    }
    return (0);
  }

  getFtthFee = (bundleOffer) => {
    let ftthFee = 0;
    if (bundleOffer.ftthactivationFee) {
      ftthFee = parseFloat(bundleOffer.ftthactivationFee);
    }
    if (ftthFee > 0.0) {
      return (bundleOffer.ftthactivationFee)
    }
    return (0);

  }

  getDropDownInfo = bundleOffer => {
    let priceIndex = 0;
    var dropDownLines = [];
    var priceBreakdown = bundleOffer.priceBreakdown;
    if (priceBreakdown.length > 1) {
      var i = priceBreakdown.length - 1;
      var price = priceBreakdown[i].priceFormatted;
      var months = priceBreakdown[i].startMonth;

      priceBreakdown.map((item, index) => {
        if (item.startMonth != 0 && item.startMonth != 1) {
          dropDownLines.push('After ' + item.startMonth + ' months:€' + item.priceFormatted);
        }
      });
      // FOR LIFE logic commented out as part of EIR-2087
      // if (months===1){
      //   dropDownLines.push('For Life :€' + price);
      // }else{
      //   dropDownLines.push('After ' + months + ' months:€' + price);
      // }
    } else {
      if (priceBreakdown[0].startMonth == 0) {
        dropDownLines.push('For Life :€' + priceBreakdown[0].priceFormatted);
      }
    }

    var activationFee = this.getActivationFee(bundleOffer.standardFees);
    if (activationFee > 0) {
      dropDownLines.push('Activation fee:€' + activationFee);
      priceIndex = 1;
    }

    let ftthFee = this.getFtthFee(bundleOffer);
    if (ftthFee > 0) {
      dropDownLines.push('Installation fee:€' + ftthFee);
      priceIndex = 1;
    }

    if (dropDownLines.length > this.state.maxDropDownLines) {
      this.setState({
        maxDropDownLines: dropDownLines.length,
      });
    }
    if (priceIndex != this.priceIndex) {
      this.priceIndex = priceIndex;
    }
    return dropDownLines;
  };

  cartContentChanged = (msg, cart) => {
    PubSub.publish(Constants.eventKeys.modalHideRetrieved, (cart.numberOfProducts > 0));
  }

  modalValueSelected = (msg, selectedToggleAttribute) => {
    this.handleToggleValueSelected(selectedToggleAttribute);
  }

  handleToggleValueSelected = (selectedToggleAttribute) => {
    let bundleOfferList = null;
    var userInputRequired = null;

    if (selectedToggleAttribute) {
      currentUser.setAttribute(this.props.toggleAttributeName, selectedToggleAttribute.value);

      // find the offers that apply to the selected value
      if (this.props.toggleAttributeName && this.props.toggleAttributeName && selectedToggleAttribute && selectedToggleAttribute.value) {
        bundleOfferList = this.props.bundleOfferLists.find(bundleOfferList => bundleOfferList.attributes.some(attribute => attribute.name && attribute.value && attribute.name.toUpperCase() === this.props.toggleAttributeName.toUpperCase() && selectedToggleAttribute.value.toUpperCase() === attribute.value.toUpperCase()));
      }
      userInputRequired = false;
    }
    else {
      if (this.state.toggleAttributes && this.state.toggleAttributes.length > 0) {
        selectedToggleAttribute = this.state.toggleAttributes[0];
      }
      userInputRequired = true;
    }

    this.setState({
      selectedToggleAttribute: selectedToggleAttribute,
      userInputRequired: userInputRequired
    });

    // fall back on the first list of offers
    if (!bundleOfferList) {
      bundleOfferList = this.props.bundleOfferLists[0];
      //console.log("Bundle offers",this.props.bundleOfferLists[0])
    }

    this.setState({
      bundleOfferList: bundleOfferList
    },
      this.getOfferData);
  };

  async getOfferData() {

    this.setState({
      isLoading: true
    });

    // get a list of bundle offer ids and a list of custom attributes (set in the CMS) for the API call back to the store application
    let bundleOfferIds = this.state.bundleOfferList.bundleOffers.map(bundleOffer => bundleOffer.id).join(',');
    let attributes = this.state.bundleOfferList.attributes.map(attribute => attribute.name + '=' + attribute.value).join('&');
    let dataUrl = this.props.dataUrl + '?bundleOfferIds=' + bundleOfferIds + '&' + attributes;
    // let dataUrl = 'https://testwww03.eir.ie/store/api/bundleSummary/mobileStandalone?bundleOfferIds=' + bundleOfferIds + '&' + attributes;
    let heroBundleOffer = this.state.bundleOfferList.bundleOffers.find(bundleOffer => bundleOffer.hero);


    let response = await fetch(dataUrl);

    this.publishModalDetails();

    this.setState({
      bundleOffers: await response.json(),
      hero: heroBundleOffer ? heroBundleOffer.id : '',
      isLoading: false
    });


  }

  publishModalDetails() {
    if (this.props.toggleAttributeName && this.props.toggleText) {
      var modalDetails = {
        isOpen: this.state.userInputRequired,
        question: this.props.toggleText,
        answers: this.state.toggleAttributes,
        selectedAnswer: this.state.selectedToggleAttribute
      }
      PubSub.publish(Constants.eventKeys.modalContentRetrieved, modalDetails);
    }
  }

  getAllToggleAttributes() {
    let toggleAttributes = [];

    this.props.bundleOfferLists.forEach(bundleOfferList => {
      toggleAttributes = toggleAttributes.concat(bundleOfferList.attributes.filter(attribute => attribute.name === this.props.toggleAttributeName));
    });

    return toggleAttributes;
  }

  showModal = () => {
    this.modal.handleToggle();
  };
  handleSubmit(event) {
    // this is where we can intercept the normal form submission and do random javascripty stuff
  }
  //strips off the html tags received from openCMS and prints only the cotent
  // renderContent = (content) => {
  //   return { __html: content };
  // }
  render() {
    //console.log("EIRCARD PROPS")
    // Create an array of tv channel logos and sort according to NavPos property, to pass on to EirCard
    const tvLogos = Object.keys(this.props.tvlogos).map(i => this.props.tvlogos[i])
    tvLogos.sort((a, b) => (parseInt(a.position) > parseInt(b.postition)) ? 1 : ((parseInt(b.position) > parseInt(a.position)) ? -1 : 0))

    if (this.state.error) {
      return (<h2 className="text-center">Error</h2>);
    }
    else if (this.state.isLoading) {
      return (<Loading className="m-5" />);
    }
    else if
      (this.state.bundleOffers == null || this.state.bundleOffers.length === 0) {
      return (<h2 className="text-center" />);
    }
    else if
      // If prequalOnly is set, then nothing is added to the cart when the submit button is pressed
      // The page will redirect to the prequal page instead
      (!this.props.prequalOnly) {
      let initialSlide = 0;

      this.state.bundleOffers.map((bundleOffer, index) => {
        if (this.state.hero === bundleOffer.id) {
          initialSlide = index;
        }
      });
      return (
        <React.Fragment>

          <form onSubmit={this.handleSubmit} action={this.state.bundleOffers[0].submitUrl || this.props.submitUrl} method="post">
            {this.state.bundleOfferList.attributes.map((attribute, index) => {
              return (
                <input type="hidden" name={attribute.name} value={attribute.value} key={index + attribute.name} />
              );
            })}

            <ResponsiveEirCardContainer
              cartSummary={this.props.cartSummary}
              count={this.state.bundleOffers.length}
              initialSlide={initialSlide}
            >

              {this.state.bundleOffers.map((bundleOffer, index) => {
                //EIR-1919 even non prequal bundle card should read promo string
                let currentOffer = this.state.bundleOfferList.bundleOffers.find(offer => offer.id === bundleOffer.id);
                //console.log("Bundle>>>>>>",currentOffer)
                return (
                  <React.Fragment key={index}>

                    <OfferModal
                      centered={true}
                      key={`eirmodal-${index}`}
                      {...bundleOffer.offer}
                      ref={modal => {
                        this.modal = modal;
                      }}
                    />

                    <EirCard
                      id={bundleOffer.id || bundleOffer.bundleCode}
                      key={'eircard-' + index}
                      name={bundleOffer.name}
                      subtitles={this.getSubtitles(bundleOffer)}
                      mainFeatures={bundleOffer.attributes.filter(attribute => attribute.name === 'mainFeature').map(attribute => attribute.value)}
                      price={bundleOffer.priceBreakdown}
                      hideContractDuration={bundleOffer.hideContractDuration}
                      hero={this.state.hero === bundleOffer.id}
                      moreDetails={this.state.moreDetails}
                      features={bundleOffer.attributes.filter(attribute => attribute.name === 'feature').map(attribute => attribute.value)}
                      footerInfos={bundleOffer.attributes.filter(attribute => attribute.name === 'footerInfo').map(attribute => attribute.value)}
                      sash={bundleOffer.attributes.filter(attribute => attribute.name === 'highlight').map(attribute => attribute.value)[0]}
                      roundel={bundleOffer.offer}
                      showModal={this.showModal}
                      ctaText={currentOffer.ctaText}
                      useChat={this.props.useChat}
                      ctaName="bundleOfferId"
                      ctaValue={bundleOffer.id || bundleOffer.bundleCode}
                      oneOffCosts={bundleOffer.oneOffCosts}
                      promo={currentOffer ? currentOffer.promo : ''}
                      promoString={currentOffer ? currentOffer.promoString : ''}
                    />
                  </React.Fragment>
                );
              })}
            </ResponsiveEirCardContainer>
          </form>
        </React.Fragment>
      );
    } else {

      // PREQUAL ONLY

      let initialSlide = 0;
      this.state.bundleOffers.map((bundleOffer, index) => {
        if (this.state.hero === bundleOffer.id) {
          initialSlide = index;
        }
      });

      let maxNumFeatures = 0;
      this.state.bundleOffers.map((bundleOffer, index) => {
        var features = bundleOffer.attributes.filter(attribute => attribute.name === 'feature').map(attribute => attribute.value)
        if (features.length > maxNumFeatures) {
          maxNumFeatures = features.length
        }
      })
      let maxDropDownLines = 0;
      this.state.bundleOffers.map((bundleOffer, index) => {
        if (bundleOffer.standardFees.length) {
          if (bundleOffer.standardFees.length > maxDropDownLines) {
            maxDropDownLines = bundleOffer.standardFees.length;
          }
        }
      })


      return (
        <React.Fragment>
          <form onSubmit={this.handleSubmit} action={this.state.bundleOffers[0].submitUrl || this.props.submitUrl} method="post">
            {this.state.bundleOfferList.attributes.map((attribute, index) => {
              return (
                <input type="hidden" name={attribute.name} value={attribute.value} key={index + attribute.name} />
              );
            })}
            <ResponsiveEirCardContainer
              cartSummary={this.props.cartSummary}
              count={this.state.bundleOffers.length}
              initialSlide={initialSlide}
              prequalOnly={this.props.prequalOnly}
            >
              {this.state.bundleOffers.map((bundleOffer, index) => {
                // var testFeatures

                let currentOffer = this.state.bundleOfferList.bundleOffers.find(offer => offer.id === bundleOffer.id);
                //console.log("Bundle>>>>>>",currentOffer)
                // GET THIS PROPERLY FROM THE DB - MSB
                // testFeatures = bundleOffer.attributes.filter(attribute => attribute.name === 'feature').map(attribute => attribute.value)

                return (
                  <React.Fragment key={index}>

                    <OfferModal
                      centered={true}
                      key={`eirmodal-${index}`}
                      {...bundleOffer.offer}
                      ref={modal => {
                        this.modal = modal;
                      }}
                    />

                    <EirCard
                      id={bundleOffer.id}
                      key={'eircard-' + index}
                      name={bundleOffer.name}
                      subtitles={(this.state.useChat===bundleOffer.id)?this.state.subtitleFake:this.getSubtitles(bundleOffer)}
                      priceBreakDown={this.getPriceBreakDown(bundleOffer)}
                      dropDownInfo={this.getDropDownInfo(bundleOffer)}
                      mainFeatures={bundleOffer.attributes.filter(attribute => attribute.name === 'mainFeature').map(attribute => attribute.value)}
                      price={(this.state.useChat===bundleOffer.id) ?this.state.priceArray:bundleOffer.priceBreakdown}
                      priceIndex={this.priceIndex}
                      hideContractDuration={currentOffer.hideContractDuration}
                      hero={this.state.hero === bundleOffer.id}
                      features={bundleOffer.attributes.filter(attribute => attribute.name === 'feature').map(attribute => attribute.value)}
                      sash={bundleOffer.attributes.filter(attribute => attribute.name === 'highlight').map(attribute => attribute.value)[0]}
                      roundel={bundleOffer.offer}
                      showModal={this.showModal}
                      ctaText={currentOffer.ctaText}
                      useChat={currentOffer.useChat}
                      ctaName="bundleOfferId"
                      ctaValue={bundleOffer.id}
                      oneOffCosts={bundleOffer.oneOffCosts}
                      moreDetails={currentOffer.moreDetails}
                      channelPopUp={currentOffer.channelPopUp}
                      prequalUrl={currentOffer.prequalUrl}
                      promo={currentOffer.promo}
                      promoString={currentOffer.promoString}
                      tvLogos={tvLogos}
                      maxNumFeatures={maxNumFeatures}
                      maxDropDownLines={this.state.maxDropDownLines}
                    />
                  </React.Fragment>
                );
              })}
            </ResponsiveEirCardContainer>

            {/* <EirCardPrequal/> */}
          </form>
          {/* <div id="prequalHTML"><p  dangerouslySetInnerHTML={this.renderContent(this.props.script)}></p>
          </div>           */}

        </React.Fragment>
      );
    }
  }
}

export default EirCardContainer;


